<div class="cvds-level">

  <div *ngIf="fieldsModel.length">
    <cv-cvds-field-table
      [items]="fieldsModel"
    ></cv-cvds-field-table>
  </div>

  <div *ngFor="let item of fieldsSections">
    <cv-cvds-field-array
      [items]="item.items"
      [fields]="item.fields"
      [title]="item.title"
    ></cv-cvds-field-array>
  </div>

  <div *ngIf="level.cv_photos?.length">
    <div class="card cv-card__main shadow-sm">
      <div class="card-header">Level Photos</div>
      <div class="card-body">
        <cv-cvds-photos 
          [photos]="level.cv_photos">
        </cv-cvds-photos>
      </div>
    </div>
  </div>

  <div class="card cv-card__main shadow-sm" *ngIf="level.rooms?.length > 0">
    <div class="card-header">Rooms</div>
    <div class="card-body">

      <cv-tab-group>
        <cv-tab [title]="room.roomType.Value" *ngFor="let room of level.rooms; let i = index;">
            <div class="padding">
              <cv-cvds-room [room]="room" [index]="i"></cv-cvds-room>
            </div>
        </cv-tab>
      </cv-tab-group>
    </div>
  </div>
</div>